"use strict";
require("./main");
